// Response envelopes for /me/files + /me/folders + /me/uploads + /me/storage.
import { z } from 'zod';
import { File, FileVersion } from './file.js';
import { Folder, FolderAncestor } from './folder.js';
import { StorageDashboard, StorageQuota } from './quota.js';
import { UploadInitResponse, UploadSession } from './upload.js';
export const FolderResponse = z.object({
    folder: Folder,
    ancestors: z.array(FolderAncestor),
});
export const FolderListResponse = z.object({
    folders: z.array(Folder),
    total: z.number().int().nonnegative(),
    limit: z.number().int().nonnegative(),
    offset: z.number().int().nonnegative(),
});
export const FolderWithChildrenResponse = z.object({
    folder: Folder,
    ancestors: z.array(FolderAncestor),
    childFolders: z.array(Folder),
    childFiles: z.array(File),
    totalFolders: z.number().int().nonnegative(),
    totalFiles: z.number().int().nonnegative(),
    limit: z.number().int().nonnegative(),
    offset: z.number().int().nonnegative(),
});
export const FileResponse = z.object({ file: File });
export const FilePreviewContent = z.discriminatedUnion('kind', [
    z.object({
        kind: z.enum(['text', 'markdown', 'code', 'office']),
        text: z.string(),
        language: z.string().nullable(),
        source: z.enum(['plain-text', 'office-open-xml']),
        bytesRead: z.number().int().nonnegative(),
        truncated: z.boolean(),
    }),
    z.object({
        kind: z.literal('unsupported'),
        reason: z.enum(['binary', 'too_large', 'legacy_office', 'empty', 'unknown']),
        label: z.string(),
    }),
]);
export const FilePreviewContentResponse = z.object({
    preview: FilePreviewContent,
});
export const FileListResponse = z.object({
    files: z.array(File),
    total: z.number().int().nonnegative(),
    limit: z.number().int().nonnegative(),
    offset: z.number().int().nonnegative(),
});
export const FileVersionsResponse = z.object({
    versions: z.array(FileVersion),
});
export const UploadInitResponseEnvelope = UploadInitResponse;
export const UploadSessionResponse = z.object({
    session: UploadSession,
});
export const UploadCompleteResponse = z.object({
    file: File,
    /** When the complete created a new version row, this carries the
     *  newly written version. */
    version: FileVersion.nullable(),
});
export const StorageQuotaResponse = z.object({ quota: StorageQuota });
export const StorageDashboardResponse = z.object({
    dashboard: StorageDashboard,
});
export const RecycleBinResponse = z.object({
    folders: z.array(Folder),
    files: z.array(File),
    totalFolders: z.number().int().nonnegative(),
    totalFiles: z.number().int().nonnegative(),
});
export const BulkResultEntry = z.object({
    fileId: z.string().uuid(),
    ok: z.boolean(),
    errorCode: z.string().nullable(),
});
export const BulkFilesResponse = z.object({
    results: z.array(BulkResultEntry),
    okCount: z.number().int().nonnegative(),
    failCount: z.number().int().nonnegative(),
});
//# sourceMappingURL=responses.js.map